import { Injectable, inject } from '@angular/core';

import { UserService } from '../user/user.service';

/**
 * @stable
 */
@Injectable({
    providedIn: 'root',
})
export class DateTimeService {
    private readonly userService = inject(UserService);

    now(): Date {
        return new Date();
    }

    getFutureDate(years = 0, days = 0, hours = 0, minutes = 0, seconds = 0): Date {
        const date = this.now();
        date.setFullYear(date.getFullYear() + years);
        date.setDate(date.getDate() + days);
        date.setHours(date.getHours() + hours);
        date.setMinutes(date.getMinutes() + minutes);
        date.setSeconds(date.getSeconds() + seconds);

        return date;
    }

    convertLocalToUserTimezone(date: Date): Date {
        const dateUTC = date.getTime() + date.getTimezoneOffset() * 60000;

        return new Date(dateUTC + 60000 * this.userService.userTimezoneUtcOffset);
    }
}
